import { render, staticRenderFns } from "./TurnProductivityCalibratorOrg.vue?vue&type=template&id=60b55c17"
import script from "./TurnProductivityCalibratorOrg.vue?vue&type=script&lang=js"
export * from "./TurnProductivityCalibratorOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports